module.exports = __webpack_public_path__ + "img/ico_msyjcj.01599fe3.png";